import { combineReducers } from 'redux'
import * as types from '../../utils/actionTypes'
import { createReducer } from '../../utils/helpers'

const initialState = {
  login: {
    intro: 'Bitte melden Sie sich an:',
    submitButton: 'anmelden',
    error: false,
  },
  loginError: false,
  jwt: false,
  steps: [
    {
      id: 1,
      title: 'Angebote',
      path: 'angebote',
      activated: true,
      restricted: false,
      images: ['images/static/admin_list.svg'],
    },
    {
      id: 2,
      title: 'Haustypen',
      path: 'haustypen',
      activated: true,
      restricted: false,
      images: ['images/static/admin_house.svg'],
    },
    {
      id: 3,
      title: 'Konfigurationen',
      path: 'konfigurationen',
      activated: true,
      restricted: false,
      images: ['images/static/admin_options.svg'],
    },
    {
      id: 4,
      title: 'Benutzer',
      path: 'benutzer',
      activated: false,
      restricted: true,
      images: ['images/static/admin_user.svg'],
    },
  ],
  activeNode: false,
}


export const login = createReducer(initialState.login, {})


const setJwt = (state, payload) => (payload !== null ? payload : false)

export const jwt = createReducer(initialState.jwt, {
  [types.SET_JWT]: setJwt,
})

const loginError = createReducer(initialState.loginError, {
  [types.LOGIN_FAILED]: () => true,
})

export const steps = createReducer(initialState.steps, {})


const setActiveNode = (state, payload) => (payload !== null ? payload : false)

export const activeNode = createReducer(initialState.jwt, {
  [types.SET_ADMIN_ACTIVE_NODE]: setActiveNode,
})


// Default Export
export default combineReducers({
  login,
  loginError,
  jwt,
  steps,
  activeNode,
})



// WEBPACK FOOTER //
// ./src/modules/admin/reducers.js